export const loadStores = (callback, url) => {
  var req = new XMLHttpRequest();
  req.open("GET", url, true);
  req.onload = function(e) {
    if (req.readyState === 4) {
      if (req.status === 200) {
        callback(true, JSON.parse(req.responseText));
      } else {
        callback(false);
      }
    }
    req.onerror = function(e) {
      callback(false);
    };
  };
  req.send();
};



// WEBPACK FOOTER //
// src/service/service.js